<template>
  <section v-if="form">
    <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;overflow:hidden;">
      <el-form-item label="调出公司:">
        {{form.department.name}}
      </el-form-item>
      <el-form-item label="调入公司:">
        {{form.inDepartment.name}}
      </el-form-item>
      <el-form-item label="调拨申请时间:">
        {{getTime(form.flow.createTime)}}
      </el-form-item>
      <el-form-item label="调拨申请人:">
        <user-info :userData='form.flow.creator'></user-info>
      </el-form-item>
      <el-form-item class="full" label="相关资产:">
        <div class="material-table">
          <el-table :data="form.assets" border>
            <el-table-column prop="number" label="资产编号" width="110px">
            </el-table-column>
            <el-table-column prop="name" label="资产名称">
            </el-table-column>
            <el-table-column prop="attribute.name" label="资产属性" width="90px">
            </el-table-column>
            <el-table-column prop="spec" label="规格型号" width="140px">
            </el-table-column>
            <el-table-column prop="price" label="购置金额" width="75px">
            </el-table-column>
            <el-table-column prop="purchaseTime" label="购置时间" width="110px">
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
    </el-form>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {},
    props: ['form', 'flowUser'],
    data() {
      return {
        // total: ''  
      }
    },
    methods: {
      getTime(time) {
        return util.getFormatDate(time, true)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/asset/components/allot.vue